import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, Edit, TextInput, Button, Create, SimpleForm, TopToolbar, FormTab, TabbedForm, FormDataConsumer, required, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, Toolbar, SaveButton, useNotify, useRedirect, DateField, Filter, downloadCSV, DateInput } from 'react-admin';import jsonExport from 'jsonexport/dist';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import GavelIcon from '@material-ui/icons/Gavel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { dateOnlyToCatalan } from './../common/utils';  

import { ExportButton } from './../components/ExportButton';

import { Link } from 'react-router-dom';

import { validateMaxLength } from './../components/Validator';export const TicketsCheckersInList = (props) => {
  const translate = useTranslate();  
    
  let basePath='/tickets_checkers_in'; 
  let resource = 'tickets_checkers_in';
  let strRedirect = 'tickets_checkers_in';
    
  return (
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={{ associations_id : localStorage.getItem('associations_id') }}  
        actions={props.show ?  <span/> : <ListActions />}    
        empty={props.show ?  <span/> : <ListActions />}        
        bulkActionButtons={false}          
        perPage={1000}   
        pagination={false}
        sort={{ field: 'id', order: 'ASC' }} 
        label=""  
        title=""  
        resource={resource}
        filters={props.show ?  <span/> : <MyFilter />} 
        filterDefaultValues={ { q: "" }}
      >        
        <Datagrid 
          rowClick={props.show ? null : 'edit'}
          expand={<TicketsCheckersInDetails />} >  
          <Avatar><GavelIcon/></Avatar>                                  
          <TextField source="events_sessions_id" label={translate('tickets_checkers_in.events_sessions_id')} sortable={false} />  
          <TextField source="tickets_checkers_id" label={translate('tickets_checkers_in.tickets_checkers_id')} sortable={false} />  
          <TextField source="bookings_items_id" label={translate('tickets_checkers_in.bookings_items_id')} sortable={false} />  
          <DateField source="scanned_at" label={translate('tickets_checkers_in.scanned_at')} sortable={false} />  
          <TextField source="mode" label={translate('tickets_checkers_in.mode')} sortable={false} />  
          <TextField source="result" label={translate('tickets_checkers_in.result')} sortable={false} />  
          <TextField source="ip" label={translate('tickets_checkers_in.ip')} sortable={false} />  
          <TextField source="user_agent" label={translate('tickets_checkers_in.user_agent')} sortable={false} />  
          <TextField source="os" label={translate('tickets_checkers_in.os')} sortable={false} />  
          <TextField source="browser" label={translate('tickets_checkers_in.browser')} sortable={false} />  
          <TextField source="comments" label={translate('tickets_checkers_in.comments')} sortable={false} />  
        </Datagrid>        
      </List>
    </ResourceContextProvider>
  );
};

const MyFilter = (props) => {
    const translate = useTranslate(); 
    return (
    <Filter {...props}>         
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable />    
    </Filter>
);
};

export const TicketsCheckersInDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>
        <Grid item xs={4}>   
          <TextFieldShow source={record.events_sessions_id} label={translate('tickets_checkers_in.events_sessions_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.tickets_checkers_id} label={translate('tickets_checkers_in.tickets_checkers_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.bookings_items_id} label={translate('tickets_checkers_in.bookings_items_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.scanned_at)} label={translate('tickets_checkers_in.scanned_at')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.mode} label={translate('tickets_checkers_in.mode')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.result} label={translate('tickets_checkers_in.result')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.ip} label={translate('tickets_checkers_in.ip')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.user_agent} label={translate('tickets_checkers_in.user_agent')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.os} label={translate('tickets_checkers_in.os')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.browser} label={translate('tickets_checkers_in.browser')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.comments} label={translate('tickets_checkers_in.comments')} />
        </Grid> 
      </Grid>
      
    </div>
  );
};

const exporter = (items, translate, notify) => {
    
  const itemsForExport = items.map(item => {
    var itemForExport = {
        id: item.id,
        events_sessions_id: item.events_sessions_id,
        tickets_checkers_id: item.tickets_checkers_id,
        bookings_items_id: item.bookings_items_id,
        scanned_at: dateOnlyToCatalan(item.scanned_at),
        mode: item.mode,
        result: item.result,
        ip: item.ip,
        user_agent: item.user_agent,
        os: item.os,
        browser: item.browser,
        comments: item.comments,
    };
    return itemForExport;
  });
  jsonExport(itemsForExport, {
    headers: ['id','events_sessions_id'
,'tickets_checkers_id'
,'bookings_items_id'
,'scanned_at'
,'mode'
,'result'
,'ip'
,'user_agent'
,'os'
,'browser'
,'comments'
],
    rename: [translate('common.id'),translate('tickets_checkers_in.events_sessions_id'),translate('tickets_checkers_in.tickets_checkers_id'),translate('tickets_checkers_in.bookings_items_id'),translate('tickets_checkers_in.scanned_at'),translate('tickets_checkers_in.mode'),translate('tickets_checkers_in.result'),translate('tickets_checkers_in.ip'),translate('tickets_checkers_in.user_agent'),translate('tickets_checkers_in.os'),translate('tickets_checkers_in.browser'),translate('tickets_checkers_in.comments')],        
        
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('tickets_checkers_in.exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
};


const ListActions = (props) => {
    const translate = useTranslate(); 
    
    let filterExport = { 
        associations_id: localStorage.getItem('associations_id'),        
        q: props.filterValues && props.filterValues.q ? props.filterValues.q : ''
    };
    
    return (
    <TopToolbar>     
        <MyCreateButton {...props} />    
        <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={false} exporter={exporter} sort={{ field: 'id', order: 'DESC' }} /> 
    </TopToolbar>
    );
};

export const MyCreateButton = ({ users_id , ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('tickets_checkers_in');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const redirect = useRedirect();
        
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {                    
          redirect('/tickets_checkers_in/' + data.id);
        
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
    
  return (
    <>            
      <Button onClick={handleClick} label={translate('tickets_checkers_in.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_checkers_in.create')}
      >
        <DialogTitle>{translate('tickets_checkers_in.create')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ associations_id: localStorage.getItem('associations_id') }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>                                     
                  <Grid item xs={12}>                                               
                    <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid>
                </Grid> 
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const MyActions = ({ basePath, data, resource }) => {

  const translate = useTranslate();   
    
  let linkBack = '/tickets_checkers_in';
        
  return (
    <>
      <TopToolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>   
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Link
                to={linkBack}
                className=""
              >
                <ArrowBackIosNewIcon className="mr-2" />                        
              </Link>
              <Typography variant="h5" className="grey8">
                {data && data.name ? data.name : null}                    
              </Typography>
            </div>  
                
          </Grid>
        </Grid> 
      </TopToolbar>
    </>
  );
};


export const TicketsCheckersInEdit  = ({ id, ...props }) => {

  const translate = useTranslate();        
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  let strRedirect =  `/tickets_checkers_in/${id}`;    
    
  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));        
    redirect('/tickets_checkers_in');        
  };
        
  return (

    <Edit 
      title={<ElementTitle {...props}  />} 
      {...props} 
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}   
    >
        
      <TabbedForm        
        toolbar={<FormToolbar />}
      >    
        <FormTab
          label={translate('classrooms.data')}
          contentClassName={classes.tab}
          path="" 
                
        > 
               
          <FormDataConsumer>
            {({ formData, ...rest }) => 
              <>                              
                <br/>
                <Grid container spacing={2}>
                  <Grid item xs={3}>   
            <TextInput fullWidth source="events_sessions_id" label={translate('tickets_checkers_in.events_sessions_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="tickets_checkers_id" label={translate('tickets_checkers_in.tickets_checkers_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="bookings_items_id" label={translate('tickets_checkers_in.bookings_items_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="scanned_at" label={translate('tickets_checkers_in.scanned_at')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="mode" label={translate('tickets_checkers_in.mode')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="result" label={translate('tickets_checkers_in.result')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="ip" label={translate('tickets_checkers_in.ip')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="user_agent" label={translate('tickets_checkers_in.user_agent')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="os" label={translate('tickets_checkers_in.os')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="browser" label={translate('tickets_checkers_in.browser')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="comments" label={translate('tickets_checkers_in.comments')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={12}>   
                  </Grid> 
                </Grid>                                

              </>
            }
          </FormDataConsumer>

        </FormTab> 
        
    
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record, ...props }) => {    
  const translate = useTranslate(); 
  return (<span>{translate('common.edit')} {record ? `"${record.name}"` : ''}</span>);
};

const FormToolbar = ({ id , ...props }) => {
    
  let redirect = '/tickets_checkers_in';
    
    
  return (
    <Toolbar {...props} className="user_form_toolbar" >
      <SaveButton />
      <DeleteButton redirect={redirect} mutationMode="pessimistic" />
    </Toolbar>
  );
};

const useStyles = makeStyles({
  comment: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    maxWidth: '100%',
    display: 'block',
  },
});






export const TicketsCheckersInCreate  = ({ id, ...props }) => {

  const translate = useTranslate();   
  const [info, setInfo] = useState();
    
  return (

    <Create {...props} >
      <SimpleForm 
        initialValues={{ associations_id: localStorage.getItem('associations_id') }}
        redirect="list"
      >                
        <Grid container spacing={2}>
          <Grid item xs={12}>                    
            <Typography variant="h5" className="grey">{translate('tickets_checkers_in.create')}</Typography>
          </Grid>  
          <Grid item xs={11}>                    
            <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
          </Grid>          
        </Grid>   

      </SimpleForm> 
    </Create>
  );
};
